import axios from 'axios'
import { getLendingTreeCardOffer } from '../helpers/lendingTree'
import { condenseParams, paramsToURL } from '../context/ApplyParamsContext'
import { getEnvVar } from '../helpers/environment'

const digitalPrescreenUrl = getEnvVar('DIGITAL_PRESCREEN_URL')

const odsAPI = axios.create({
  baseURL: digitalPrescreenUrl,
  withCredentials: true
})

export const ODSApiCallHelper = async (values, odsData) => {
  const { odsType, brandId, rewardsStrategyUuid } = odsData
  const {
    data: { token }
  } = await odsAPI.get('/token')

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }

  const trimmedForm = {
    desiredProduct: odsType,
    firstName: values.first_name,
    lastName: values.last_name,
    email: values.email,
    addressLine1: values.street,
    city: values.city,
    state: values.state,
    postalCode: values.zipcode.replace('-', ''),
    services: [],
    ...(brandId && { brand: brandId }),
    ...(rewardsStrategyUuid && { rewards: rewardsStrategyUuid })
  }

  const odsResponse = await odsAPI.post('/offers', trimmedForm, config)
  return { response: odsResponse.data, extraInformation: odsData }
}

export const OdsSSNApiCallHelper = async (values, offerId, odsData) => {
  const { singlePageExperience, applyParams, affiliateId, strategyData } = odsData
  let ssnResponse
  try {
    if (singlePageExperience) {
      const paramsCombined = condenseParams(applyParams)
      const urlParams = paramsToURL(paramsCombined.extraApplyParams)
      ssnResponse =
        affiliateId === 'lendingtree'
          ? getLendingTreeCardOffer(strategyData)
          : await odsAPI.get(`/offers/${offerId}/details?partner=${affiliateId}${urlParams}`)
    } else {
      ssnResponse = await odsAPI.get(
        `/offers/${offerId}/details?authorization_code=${values.last_4_of_ssn}`
      )
    }
    return { ssnApiResponse: ssnResponse.data }
  } catch (error) {
    if (error.response.status === 429) return { ssnApiResponse: 'fatalError' }
    return { ssnApiResponse: null }
  }
}
